import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-center items-center w-full gap-6 mb-6 max-sm:flex-wrap flex-row" }
const _hoisted_3 = { class: "meeting-engagement-requirements-block border border-[#EAECF0] rounded-2xl p-6 bg-white shadow-card relative h-full w-full max-sm:w-full" }
const _hoisted_4 = { class: "flex justify-between w-full" }
const _hoisted_5 = { class: "mb-1 text-[#101828] font-semibold text-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "engagementGraph",
  class: "w-full h-80"
}, null, -1)
const _hoisted_7 = { class: "flex w-full gap-6 flex-col" }
const _hoisted_8 = { class: "meeting-engagement-requirements-block border border-[#EAECF0] rounded-2xl p-6 bg-white shadow-card relative w-full max-sm:overflow-x-scroll" }
const _hoisted_9 = { class: "mb-1 text-[#101828] font-semibold text-lg" }
const _hoisted_10 = {
  key: 0,
  class: "w-full flex justify-center items-center p-3"
}
const _hoisted_11 = {
  key: 1,
  class: "w-full"
}
const _hoisted_12 = { class: "px-6 py-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "px-6 py-3" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex justify-between items-center mt-3 mb-4 px-6" }
const _hoisted_21 = { class: "text-[#344054] text-sm font-medium" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "meeting-engagement-requirements-block border border-[#EAECF0] rounded-2xl p-6 bg-white shadow-card relative w-full" }
const _hoisted_25 = { class: "mb-1 text-[#101828] font-semibold text-lg" }
const _hoisted_26 = { class: "rounded-md bg-red-100 p-4 mt-4" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "15",
      height: "15",
      rx: "7.5",
      fill: "#FDA29B"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.03125 9.0625V3.125H7.96875V9.0625H7.03125ZM7.03125 11.875V10.9375H7.96875V11.875H7.03125Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_29 = { class: "ml-3 flex-1 md:flex md:justify-between items-center w-full" }
const _hoisted_30 = { class: "alert-text flex flex-row justify-between w-full" }
const _hoisted_31 = { class: "text-md text-red-800 font-semibold" }
const _hoisted_32 = { class: "text-sm text-white font-bold bg-[#FD87B4] rounded-md py-1 px-5" }
const _hoisted_33 = {
  key: 0,
  class: "w-full flex justify-center items-center p-3"
}
const _hoisted_34 = { class: "w-full mt-6" }
const _hoisted_35 = { class: "px-6 py-3" }
const _hoisted_36 = { class: "px-6 py-3" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { class: "flex justify-between items-center mt-3 mb-4 px-6" }
const _hoisted_43 = { class: "text-[#344054] text-sm font-medium" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]

import { ref, onMounted, computed } from "vue";
import * as echarts from "echarts";
import { useActivityStore } from "@/stores/activityStore";
import { useRolloverStore } from "@/stores/rolloverStore";
import { useActivityLogStore } from "@/stores/activityLoggerStore";

// stores
const itemsPerPage = 10;

// loop through activity data and remove v-if="actorType != 'system'"
const itemsPerPageRollover = 10;

// paginated data

export default /*#__PURE__*/_defineComponent({
  __name: 'TrackSelectionComponent',
  setup(__props) {


// imports
const activityStore = useActivityStore();
const rolloverStore = useRolloverStore();
const activityLogStore = useActivityLogStore();

// variables
const menuToggle = ref("");
const rolloverData = ref<any[]>([]);
const activityLogData = ref<any[]>([]);
const isLoadingRollover = ref(true);
const isLoadingActivity = ref(true);

// get data from the store
onMounted(async () => {
    isLoadingRollover.value = true;
    await rolloverStore.fetchAllRollovers();
    rolloverData.value = rolloverStore.allRollovers as unknown as any[];
    isLoadingRollover.value = false;

    isLoadingActivity.value = true;
    await activityLogStore.fetchActivityLogs();
    console.log("activity logs: ", activityLogStore.activityLogs);
    activityLogData.value = activityLogStore.activityLogs as unknown as any[];
    isLoadingActivity.value = false;
});

// handle pagination for activity log
const currentPage = ref(1);
const filteredActivityLogData = computed(() => {
  return activityLogData.value.filter((activity) => activity.actorType !== "system");
});

// sort the data by date (newest to oldest)
const sortedActivityLogData = computed(() => {
  return [...filteredActivityLogData.value].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
});

// compute the total number of pages
const totalPages = computed(() =>
  Math.ceil(sortedActivityLogData.value.length / itemsPerPage)
);

// compute the paginated data
const paginatedDataActivityLog = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return sortedActivityLogData.value.slice(startIndex, endIndex);
});

// go to previous page
function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
}

// go to the next page
function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
}

// filter by learnerRollover status
const filteredRolloverData = computed(() => {
  return rolloverData.value.filter(
    (school) => school.status.learnerRollover === "to_do" && school.isComplete === false
  );
});

// filter by rolloverDate (within a month before or in the past)
const filteredRolloverDataByDate = computed(() => {
  const today = new Date();
  const oneMonthBeforeToday = new Date(today);
  oneMonthBeforeToday.setMonth(today.getMonth() - 1);

  return filteredRolloverData.value.filter((school) => {
    const rolloverDate = new Date(school.rolloverDate);
    return rolloverDate <= today || rolloverDate <= oneMonthBeforeToday;
  });
});

// sort the filtered data by rolloverDate (oldest to newest)
const sortedRolloverData = computed(() => {
  return [...filteredRolloverDataByDate.value].sort(
    (a, b) =>
      new Date(a.rolloverDate).getTime() - new Date(b.rolloverDate).getTime()
  );
});

// handle pagination for sorted data
const currentPageRollover = ref(1);
const paginatedDataRollover = computed(() => {
  const start = (currentPageRollover.value - 1) * itemsPerPageRollover;
  const end = start + itemsPerPageRollover;
  return sortedRolloverData.value.slice(start, end);
});

// calculate total pages
const totalPagesRollover = computed(() => {
  return Math.ceil(sortedRolloverData.value.length / itemsPerPageRollover);
});

// go to the previous page
function prevPageRollover() {
  if (currentPageRollover.value > 1) {
    currentPageRollover.value--;
  }
}

// go to the next page
function nextPageRollover() {
  if (currentPageRollover.value < totalPagesRollover.value) {
    currentPageRollover.value++;
  }
}

// echarts code
onMounted(() => {
    // Check if the chart container exists
    setTimeout(() => {
        type EChartsOption = echarts.EChartsOption;

        var chartDom = document.getElementById('engagementGraph')!;
        // var chartDom2 = document.getElementById('onboardingGraph')!;
        var myChart = echarts.init(chartDom);
        // var myChart2 = echarts.init(chartDom2);
        var option: EChartsOption;
        // var option2: EChartsOption;

        const loginTaskData1 = computed(
            () => activityStore?.getLoginActivityData as unknown as any[]
        );

        console.log("login data 1: ", loginTaskData1.value);

        const last30Days = [];
        const months = [];
        const today = new Date();

        // Function to generate the last 30 days
        function getLast30Days() {
            const dates = [];
            for (let i = 0; i < 30; i++) {
                const date = new Date(today);
                date.setDate(today.getDate() - i);
                dates.push(date.toISOString().split("T")[0]);
            }
            return dates.reverse(); // Oldest to newest
        }

        const allDates = getLast30Days();

        // Map the loginTaskData1 to create a dictionary of login counts
        const loginDataMap = (loginTaskData1.value || []).reduce((map, entry) => {
            map[entry.login_date.value] = entry.count || 0; // Map date to count
            return map;
        }, {} as Record<string, number>);

        // Generate the last 30 days' dates
        for (let i = 29; i >= 0; i--) {
            const date = new Date();
            date.setDate(today.getDate() - i);

            // Format the day as '01', '02', etc.
            const day = date.getDate().toString().padStart(2, '0');
            last30Days.push(day);

            // Check for a new month and store it only once
            if (i === 29 || date.getMonth() !== today.getMonth() - Math.floor(i / 30)) {
                months.push(date.toLocaleString("default", { month: "long" }));
            } else {
                months.push("");
            }
        }

        // Create the series data for the bar chart
        const seriesData = allDates.map((date) => loginDataMap[date] || 0);

        console.log("Series Data for Last 30 Days:", seriesData);

        // bar graph
        option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'shadow'
                }
            },
            xAxis: [
                {
                type: 'category',
                name: "Month",
                data: allDates,
                axisTick: {
                    alignWithLabel: true
                },
                nameLocation: "middle",
                nameTextStyle: {
                    fontWeight: "bold",
                    fontSize: 12,
                    padding: 30,
                    color: "#475467",
                },
                axisLabel: {
                    interval: 0,
                    fontSize: 10,
                    color: "#475467",
                    // rotate: 45,
                    formatter: function (value, index) {
                        const date = new Date(value);
                        const day = date.getDate();
                        const month = date.toLocaleString("default", { month: "short" });

                        if (index === 0 || day === 1) {
                        return `${day}\n\n${month}`; // Show month only on the first day and the 1st of a month
                        }
                        return `${day}`; // Show day number on all other labels
                    },
                },
                
                },
            ],
            yAxis: [
                {
                    name: "Students",
                    type: "value",
                    nameLocation: "middle",
                    nameTextStyle: {
                        fontWeight: "bold",
                        fontSize: 12,
                        padding: 20,
                        color: "#475467",
                    },
                }
            ],
            series: [
                {
                    name: 'Students',
                    type: 'bar',
                    barWidth: '10px',
                    barGap: "30px",
                    data: seriesData,
                    itemStyle: {
                        borderRadius: [5, 5, 0, 0],
                        color: "#2970FF",
                    },
                }
            ],
            grid: {
                bottom: 100,
            },
            graphic: months.map((month, index) => ({
                type: "text",
                left: `${(index * 100) / 30}%`,
                top: "100%",
                style: {
                text: month,
                font: "bold 12px Arial",
                fill: "#475467",
                textAlign: "center",
                },
            })),
        };

        // pie chart
        // const data = [
        //     { value: 29, name: 'Completed' },
        //     { value: 39, name: 'In progress' },
        //     { value: 29, name: 'Not started' },
        // ];

        // const total = data.reduce((sum, item) => sum + item.value, 0);

        // option2 = {
        //     tooltip: {
        //         trigger: 'item'
        //     },
        //     series: [
        //         {
        //             type: "pie",
        //             radius: ["40%", "50%"],
        //             center: ["25%", "50%"],
        //             avoidLabelOverlap: false,
        //             label: {
        //                 show: false,
        //                 position: "",
        //             },
        //             labelLine: {
        //                 show: true,
        //             },
        //             itemStyle: {
        //                 color(params) {
        //                     const colors = ["#73E2A3", "#ABEFC6", "#FDA29B"];
        //                     return colors[params.dataIndex];
        //                 },
        //                 borderRadius: 10,
        //                 borderColor: '#fff',
        //                 borderWidth: 2
        //             },
        //             name: 'Teacher onboarding completion',
        //             data
        //         }
        //     ],
        //     legend: {
        //         top: "40%",
        //         right: "25%",
        //         orient: "vertical",
        //         textStyle: {
        //             color: "#475467",
        //         },
        //         formatter: (name) => {
        //             const item = data.find((d) => d.name === name);
        //             const percentage = item ? ((item.value / total) * 100).toFixed(1) : 0;
        //             return item ? `${name}: ${item.value}%` : name;
        //         },
        //     },
        // };

        option && myChart.setOption(option);
        // option2 && myChart2.setOption(option2);

    }, 300); // Adjust delay as needed
});

// Date, Champion, School, Notes
const tableDataHeaders = ["Date", "User", "School", "Description"];

// table headers data
const schooolTableHeaders = ["School Name", "Champion", "Status", "Rollover Date"];

// computed property to calculate the count of unique school names
const uniqueSchoolCount = computed(() => {
  const uniqueSchools = new Set(filteredRolloverData.value.map((school:any) => school.school.name));
  return uniqueSchools.size;
});


return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (menuToggle.value == '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("internal_view.track_screen.engagement")), 1)
            ]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("internal_view.track_screen.changes_made")), 1),
            (isLoadingActivity.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_spinner_loader)
                ]))
              : (_openBlock(), _createElementBlock("table", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableDataHeaders, (header, index) => {
                    return _createElementVNode("th", {
                      key: index,
                      class: "px-6 py-3 text-left text-xs text-[#475467] font-medium"
                    }, _toDisplayString(header), 1)
                  }), 64)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDataActivityLog.value, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass([index % 2 === 1 ? 'bg-[#eaecf0] rounded-lg' : '', "text-xs text-[#475467] font-medium"])
                      }, [
                        _createElementVNode("td", {
                          class: _normalizeClass([
                            'px-6 py-3',
                            index % 2 === 1 ? 'rounded-l-lg' : ''
                          ])
                        }, _toDisplayString(new Date(row.createdAt).toISOString().split('T')[0]), 3),
                        _createElementVNode("td", _hoisted_12, [
                          (row.actorDetails)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.actorDetails.firstName) + " " + _toDisplayString(row.actorDetails.lastName), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("internal_view.track_screen.no_user_assigned")), 1))
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          (row.school)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.school.name), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("internal_view.track_screen.no_school_assigned")), 1))
                        ]),
                        _createElementVNode("td", {
                          class: _normalizeClass([
                            'px-6 py-3',
                            index % 2 === 1 ? 'rounded-r-lg' : ''
                          ])
                        }, [
                          (row.details.metadata.payload && row.details.metadata.payload.designation)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "New " + _toDisplayString(row.details.metadata.payload.designation) + " added - " + _toDisplayString(row.details.metadata.payload.email), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row.details.note), 1))
                        ], 2)
                      ], 2))
                    }), 128))
                  ])
                ])),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.page")) + " " + _toDisplayString(currentPage.value) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.of")) + " " + _toDisplayString(totalPages.value), 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: prevPage,
                  disabled: currentPage.value === 1,
                  class: "text-[#344054] text-sm font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg disabled:opacity-50 mr-3"
                }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.previous")), 9, _hoisted_22),
                _createElementVNode("button", {
                  onClick: nextPage,
                  disabled: currentPage.value === totalPages.value,
                  class: "text-[#344054] text-sm font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg disabled:opacity-50"
                }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.next")), 9, _hoisted_23)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t("internal_view.track_screen.pending_rollover")), 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("internal_view.track_screen.pending_rollover")), 1),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(uniqueSchoolCount.value) + " " + _toDisplayString(_ctx.$t("internal_view.track_screen.schools")), 1)
                  ])
                ])
              ])
            ]),
            (isLoadingRollover.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createVNode(_component_spinner_loader)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_34, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(schooolTableHeaders, (header, index) => {
                return _createElementVNode("th", {
                  key: index,
                  class: "px-6 py-3 text-left text-xs text-[#475467] font-medium"
                }, _toDisplayString(header), 1)
              }), 64)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDataRollover.value, (school, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(["text-xs text-[#475467] font-medium", index % 2 === 1 ? 'bg-[#eaecf0] rounded-lg' : '']),
                    key: index
                  }, [
                    _createElementVNode("td", {
                      class: _normalizeClass([
                                    'px-6 py-3',
                                    index % 2 === 1 ? 'rounded-l-lg' : ''
                                ])
                    }, _toDisplayString(school.school.name), 3),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(school.schoolChampions[0]?.firstName || 'No champion assigned') + " " + _toDisplayString(school.schoolChampions[0]?.lastName), 1),
                    _createElementVNode("td", _hoisted_36, [
                      (school.status.learnerRollover === 'in_review' && school.status.classReview  === 'to_do' && school.status.learnerAssignment  === 'to_do')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t("internal_view.track_screen.rollover_review")), 1))
                        : _createCommentVNode("", true),
                      (school.status.learnerRollover === 'to_do' && school.status.classReview  === 'to_do' && school.status.learnerAssignment  === 'to_do')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("internal_view.track_screen.rollover_not_started")), 1))
                        : _createCommentVNode("", true),
                      (school.status.learnerRollover === 'complete' && school.status.classReview  === 'complete' && school.status.learnerAssignment  === 'complete' && school.isComplete === false)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t("internal_view.track_screen.pending_completion")), 1))
                        : _createCommentVNode("", true),
                      (school.status.learnerRollover === 'complete')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t("internal_view.track_screen.class_review_progress")), 1))
                        : _createCommentVNode("", true),
                      (school.status.learnerRollover === 'complete' && school.status.classReview === 'complete')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t("internal_view.track_screen.learner_assignment_pending")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass([
                                    'px-6 py-3',
                                    index % 2 === 1 ? 'rounded-r-lg' : ''
                                ])
                    }, _toDisplayString(new Date(school.rolloverDate).toISOString().split('T')[0]), 3)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.page")) + " " + _toDisplayString(currentPageRollover.value) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.of")) + " " + _toDisplayString(totalPagesRollover.value), 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: prevPageRollover,
                  disabled: currentPageRollover.value === 1,
                  class: "text-[#344054] text-sm font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg disabled:opacity-50 mr-3"
                }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.previous")), 9, _hoisted_44),
                _createElementVNode("button", {
                  onClick: nextPageRollover,
                  disabled: currentPageRollover.value === totalPagesRollover.value,
                  class: "text-[#344054] text-sm font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg disabled:opacity-50"
                }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.next")), 9, _hoisted_45)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})